import GuideStickyFooter from './GuideStickyFooter';
export default GuideStickyFooter;
